import { mergeClassNames } from '@/lib/utils';
import { PropsWithChildren } from 'react';

export const PageContainer = ({
  className,
  children,
  ...props
}: PropsWithChildren<React.ComponentProps<'div'>>) => {
  return (
    <div
      className={mergeClassNames(
        'md:max-w-[800px] space-y-5 sm:space-y-6 w-full mx-auto',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
